export default __webpack_public_path__ + "static/media/disabledFileIcon.52baad39.svg";